import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { query, collection, where, documentId } from "firebase/firestore";
import ScrollContainer from "react-indiana-drag-scroll";

const Winners = ({ tournament }) => {
  const firestore = useFirestore();
  const { t } = useTranslation();
  const [winners, setWinners] = useState([]);
  const scrollContainerRef = useRef(null);
  const winnerQuery = query(
    collection(firestore, "users"),
    where(documentId(), "in", tournament?.winners)
  );

  const { status: winnerStatus, data: winnerData } = useFirestoreCollectionData(
    winnerQuery,
    {
      idField: "id",
    }
  );

  useEffect(() => {
    if (winnerData) {
      setWinners(winnerData);
    }
  }, [winnerData]);

  let winnersContent = winners?.map((item, index) => {
    return (
      <div className="flex flex-col items-center shrink-0" key={item.id}>
        <img
          src={item.photo_80x80}
          className="rounded-full w-10 h-10 border border-white"
          alt=""
        />
        <div className="grid items-center max-w-[3.5rem]">
          <div className="truncate text-white text-xs font-normal">
            {item?.nickname ? item.nickname : item?.name?.split(" ")[0]}
          </div>
        </div>
      </div>
    );
  });

  return winnerStatus != "success" ? (
    <></>
  ) : (
    <div className="flex flex-col items-center justify-center text-black">
      <div className="flex bg-black/50 text-white rounded-md p-2 py-1 w-fit ">
        {winners?.length > 1 ? t("lobby.card.winners") : t("lobby.card.winner")}
      </div>
      <div className="flex items-center justify-center space-x-4 py-2 overflow-y-auto">
        <ScrollContainer
          className="scroll-container flex space-x-2 group px-2"
          vertical={false}
          innerRef={scrollContainerRef}
        >
          {winnersContent}
        </ScrollContainer>
      </div>
    </div>
  );
};

export default Winners;
